import React from 'react';
import { Navigate, Params } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { UpsertMembershipActiveStep } from './Membership.enum';
import MembershipStore from './MembershipStore';
import { UtilityMethods,withRouter } from '@mindmemobile/mm-shared-global';

interface IProps {
    membershipStore?: MembershipStore;
    children: React.ReactElement;
    currentRoute: string;
    params: Readonly<Params<string>>;
}

const ProtectedRoute: React.FC<IProps> = ({ children, currentRoute, membershipStore, params }) => {
    let isValid = false;
    const membershipId = () => {
        const split = ((params && params['*']) || '').split('/');
        const id = split[split.length - 1];
        if (UtilityMethods.isValidObjectId(id)) {
            return id;
        }
        return null;
    };

    switch (membershipStore?.activeStep) {
        case UpsertMembershipActiveStep.Detail:
            isValid = currentRoute === 'detail';
            break;
        case UpsertMembershipActiveStep.Pricing:
            isValid = currentRoute === 'pricing';
            break;
        case UpsertMembershipActiveStep.Options:
            isValid = currentRoute === 'options';
            break;
    }

    const queryParam: string = membershipId() ? `/${membershipId()}` : '';
    return isValid ? children : <Navigate to={`/app/membership/detail${queryParam}`} />;
};

export default inject('membershipStore')(withRouter(observer(ProtectedRoute)));
